/**
 * Domains whose backend uses the dual-prefix multi-extension scheme
 * (paired physical `9999*` + mobile-app `9998*` extensions).
 *
 * Kept as a hardcoded list because the system can autoload an
 * `environment.json` over the bundled environments — putting a flag
 * on each env object isn't reliable. Adding a new ship: add the
 * domain string here.
 */
const multiextensiondomains = [
  "cpl.hap.ntlk.co",
  "mpl.hap.ntlk.co",
  "kpl.hap.ntlk.co",
  "dpl.hap.ntlk.co",
  "fph.hap.ntlk.co",
  "faw.hap.ntlk.co",
  "cht.hap.ntlk.co",
  "dns.hap.ntlk.co",
  "sgw.hap.ntlk.co",
  "ydw.hap.ntlk.co",
  "ewc.hap.ntlk.co",
];

export const isMultiExtension = (domain) => multiextensiondomains.includes(domain);

export default multiextensiondomains;
